'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
const VISIBLE_RESTORE_LINES = 3;

/**
 * A restore records one entry per selected item, so a bulk job fills the details panel with a list
 * no one reads. Only the first few are shown, and the copy button appears with them: it carries the
 * whole list, which is the only way to reach the entries trimmed out of view.
 *
 * useFields keeps a row when the element its Component returns is truthy, so an empty value must
 * resolve to null here rather than inside a child that renders null later.
 */
export const RestoreValueLines = t0 => {
  const $ = _c(15);
  const {
    lines,
    textToCopy
  } = t0;
  if (!lines.length) {
    return null;
  }
  const hiddenCount = lines.length - VISIBLE_RESTORE_LINES;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "flex-start",
      gap: "8px",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "8px",
      minWidth: "0"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== lines) {
    t3 = lines.slice(0, VISIBLE_RESTORE_LINES);
    $[2] = lines;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hiddenCount) {
    t4 = hiddenCount > 0 && <Typography variant="body2">{`+${hiddenCount} more`}</Typography>;
    $[4] = hiddenCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack sx={t2}>{t3}{t4}</Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== hiddenCount || $[10] !== textToCopy) {
    t6 = hiddenCount > 0 && <Box sx={{
      flexShrink: 0,
      marginLeft: "auto"
    }}><CopyToClipboardButton textToCopy={textToCopy} size="small" tooltip="Copy all" /></Box>;
    $[9] = hiddenCount;
    $[10] = textToCopy;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Stack direction="row" sx={t1}>{t5}{t6}</Stack>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};